/** EPM Efficient Power Management (formerly AEU - IOT version) */
import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatDuration } from "@signolteam/shared/units-of-measure";

let defaultMetadata = {
  overproduced_hours: 2,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  bvrColour,
  metadata = defaultMetadata,
  missingDataMsg,
  isExample,
}) {
  let overproducedHours = metadata["overproduced_hours"];
  const threshold = 3;

  if (!overproducedHours) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }
  let actual = Number(overproducedHours);

  const data = [
    {
      name: "Measured overproduction hours",
      mobileName: "Label 1",
      beforeThreshold: actual > threshold ? threshold : actual,
      afterThreshold: actual > threshold ? actual - threshold : 0,
      underThresholdColour:
        actual > threshold ? bvrColour.codes["200"] : bvrColour.codes["500"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMin = 0;
  const margin = actual < threshold ? 0.2 * threshold : 0.2 * actual;
  const domainMax =
    actual < threshold
      ? Math.ceil((threshold + margin) / 10) * 10
      : Math.ceil((actual + margin) / 10) * 10;
  const domain = [domainMin, domainMax];

  const mobileMargin = actual < threshold ? 0.05 * threshold : 0.05 * actual;
  const mobileDomainMax =
    actual < threshold
      ? Math.ceil(threshold + mobileMargin)
      : Math.ceil(actual + mobileMargin);
  const mobileDomain = [domainMin, mobileDomainMax];

  const thresholdLineColour = bvrColour.codes["900"];

  const actual_seconds = actual * 60 * 60;
  const threshold_seconds = threshold * 60 * 60;

  return (
    <BehaviourBarGraph
      data={data}
      threshold={threshold}
      thresholdLabel={`Signol threshold (${
        formatDuration(threshold_seconds, {
          boundaryValues: [0, actual_seconds],
        }).formattedValue
      })`}
      mobileDomain={mobileDomain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={actual < threshold}
      axisLabel={`Overproduction hours`}
      hideYLine={true}
      hideNum={true}
      barLabelFormatter={() =>
        formatDuration(actual_seconds, {
          boundaryValues: [0, threshold_seconds],
        }).formattedValue
      }
      isExample={isExample}
    />
  );
}
